import { render, staticRenderFns } from "./DiagnosisText.vue?vue&type=template&id=7dd98828&scoped=true&"
import script from "./DiagnosisText.vue?vue&type=script&lang=js&"
export * from "./DiagnosisText.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosisText.vue?vue&type=style&index=0&id=7dd98828&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd98828",
  null
  
)

export default component.exports